"use strict";

import React, { PropTypes } from 'react';
import ProportionBar from './ProportionBar.js';

const Details = React.createClass({
  displayName: "Details",
  propTypes: {
    item: PropTypes.object
  },
  constructName(name) {
    const [firstName, lastName] = name.split(' ');
    const css = require('./Details.scss');
    return (
      <span>
        <span className={css.winnerFirstName}>{firstName} </span>
        <span className="winner-last-name">{lastName}</span>
      </span>
    );
  },

  renderCandidateResults(candidate, total, party) {
    const css = require('./Details.scss');
    return (
      <li className={css.profile} key={candidate.name}>
        {candidate.delegates > 0 &&
          <div>
            <p>{this.constructName(candidate.name)}</p>
            <ProportionBar total={+total} part={candidate.delegates} delegates={candidate.delegates} party={party} showingPercentage={false} />
          </div>
        }
      </li>
    );
  },

  render() {
    const item = this.props.item;
    const { republicans, democrats } = item.results;
    const height = window.innerWidth > 471 ? 275 : 285;
    const css = require('./Details.scss');
    return (
        <li key={item.state_short} className={css.primListItemDetails}>
          <hr style={{borderColor: '#ccc'}} />
          <h3 className={css.info}>Mer information om {item.state}</h3>
          <p className={css.intro} dangerouslySetInnerHTML={{__html: item.text}} />

          {item.delegates_r > 0 &&
            <div>
              <p className={css.header}>Republikanerna – {item.delegates_r} delegater (+{item.superdelegates_r || 0} obundna delegater)</p>
              <ul className={css.profileList}>{republicans.slice(0,3).map((c) => this.renderCandidateResults(c, item.delegates_r, 'r'))}</ul>
            </div>
          }

          {item.delegates_d > 0 &&
            <div>
              <p className={css.header}>Demokraterna – {item.delegates_d} delegater (+{item.superdelegates_d || 0} obundna delegater)</p>
              <ul className={css.profileList}>{democrats.map((c) => this.renderCandidateResults(c, item.delegates_d, 'd'))}</ul>
            </div>
          }
        </li>
    );
  }
});

export default Details;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Details.js
 **/